import Highcharts from "highcharts";
import Accessibility from "highcharts/modules/accessibility";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { useIntl } from "react-intl";

import { themeSlice } from "@tdp/common/theme";
import { useSelector } from "@tdp/core";
import { EmptyState, getLocalisedFilterContent, useFilterFormattedString } from '@tdp/modules/apps'

import { containerStyle, getStyles } from "./Charts.Styles";
import { ChartType, IBarChartValues, removeWatermark } from "./IAnalyticsCharts";

// Initialize the Highcharts accessibility module
// https://www.highcharts.com/docs/accessibility/accessibility-module#describing-your-chart
Accessibility(Highcharts);

export const ChartBar: React.FC<{ data?: IBarChartValues; legend: string; horizontal?: boolean }> = ({
  data,
  legend,
  horizontal
}) => {
  const chartType = horizontal ? ChartType.BAR : ChartType.COLUMN;
  // const themes: Themes = useAppSelector((state) => state.themes).themes || Themes.Default;
  const currentTheme = useSelector(themeSlice.selectors.getCurrentTheme);
  // const themes: Themes = useAppSelector((state) => state.themes).themes || Themes.Default;
  const style = getStyles(currentTheme);
  const intl = useIntl();
  const filterFormattedStrings = useFilterFormattedString(intl);

  if (!data) {
    return <EmptyState />;
  }

  const categories = Object.keys(data).map((key) => getLocalisedFilterContent(intl, key, filterFormattedStrings));

  const chartOptions = {
    chart: {
      type: chartType,
      backgroundColor: style.backgroundColor
    },
    colors: style.lineColors,
    title: null,
    xAxis: {
      categories
    },
    yAxis: {
      title: null
    },
    series: [
      {
        name: legend,
        data: Object.values(data)
      }
    ],
    legend: {
      itemStyle: {
        color: style.legend
      }
    },
    tooltip: {
      ...style.tooltip
    },
    ...removeWatermark
  };

  return <HighchartsReact containerProps={containerStyle} highcharts={Highcharts} options={chartOptions} />;
};

export default React.memo(ChartBar);
